import { Text } from '@doda/io-react/common';
import { SectionTitle } from '../../SectionTitle';
import { SectionItem } from '../../SectionItem';
import { AccordionItem } from './AccordionItem';
import { LightBlueSubTitle } from '../LightBlueSubTitle';
import styles from './index.module.scss';

/**
 * 応募方法（エージェント）
 */
export const JobOfferKindAgent: React.FC = () => {
  const otoiawase = (
    <a
      href="/otoiawase/otoiawase.html"
      target="_blank"
      className={styles['jobSearchDetail-jobOfferKindAgent__link']}
    >
      お問い合わせフォーム
    </a>
  );

  return (
    <div className={styles['jobSearchDetail-jobOfferKindAgent']}>
      <SectionTitle mb="L" border>
        応募方法
      </SectionTitle>
      <SectionItem label="応募方法">
        <div className={styles['jobSearchDetail-jobOfferKindAgent__caption']}>
          <Text size="14--articlePC" weight="bold" color="black_pc">
            この求人情報は、dodaエージェントサービスの
            <a
              href="/info/help/about_pa.html"
              target="_blank"
              className={styles['jobSearchDetail-jobOfferKindAgent__link']}
            >
              採用プロジェクト担当
            </a>
            を通じての受付となります。
          </Text>
        </div>
        <div
          className={styles['jobSearchDetail-jobOfferKindAgent__contentWrap']}
        >
          <LightBlueSubTitle label="応募の流れ" />
          <ul className={styles['jobSearchDetail-jobOfferKindAgent__content']}>
            <Text size="14--articlePC" color="black_pc" as="li">
              「応募依頼する」ボタンを押すと、ご応募と同時にdodaエージェントサービスの登録が完了します。
            </Text>
            <Text size="14--articlePC" color="black_pc" as="li">
              ご応募後、
              <a
                href="/info/help/about_resumeupload.html"
                target="_blank"
                className={styles['jobSearchDetail-jobOfferKindAgent__link']}
              >
                職務経歴書のアップロード
              </a>
              がお済みでない方は、できる限りお早めにご提出をお願いします。
            </Text>
            <Text size="14--articlePC" color="black_pc" as="li">
              採用条件に合致した方については、dodaエージェントサービスにご提出いただいた情報
              にて、そのまま企業への応募手続きをいたします。
            </Text>
            <Text size="14--articlePC" color="black_pc" as="li">
              ご応募についての合否に関わるご連絡は、この求人情報を担当する採用プロジェクト担当から行います。
            </Text>
          </ul>
        </div>
        <div
          className={styles['jobSearchDetail-jobOfferKindAgent__contentWrap']}
        >
          <LightBlueSubTitle label="応募前・応募直後によくある質問" />
          <AccordionItem title="応募後は担当キャリアアドバイザーがサポートしますか？">
            本求人よりご応募された場合、採用プロジェクト担当がサポートします。担当のキャリアアドバイザーを通じたサポートをご希望の場合は、その旨を記載のうえ、企業名と求人名を添えて、担当キャリアアドバイザーへご連絡ください。
          </AccordionItem>
          <AccordionItem
            title="ポートフォリオを提出したいのですが？"
            caption="※ご質問の種類は、「dodaエージェントサービスについて」をご選択ください。"
          >
            {otoiawase}
            より、該当する企業名と求人名、またポートフォリオを提出されたい旨を記載のうえ、ご連絡ください。
            <br />
            求人情報を担当する採用プロジェクト担当より、改めてご連絡いたします。
          </AccordionItem>
          <AccordionItem
            title="特定企業への志望動機書や自己PRを提出したいのですが？"
            caption="※ご質問の種類は、「dodaエージェントサービスについて」をご選択ください。"
          >
            {otoiawase}
            より、該当する企業名と求人名、また志望動機書や自己PRを提出したい旨を記載のうえ、ご連絡ください。
            <br />
            求人情報を担当する採用プロジェクト担当より、改めてご連絡いたします。
          </AccordionItem>
          <AccordionItem title="応募後、「選考準備中」のままですが、選考は進んでいるのでしょうか？">
            「選考準備中」とは、採用プロジェクト担当が、企業提出前に書類を確認している状態です。採用条件に合致しているか、およびキャリアシートやアップロードいただいた書類に不備がないかを確認しています。
            <br />
            なお、選考状況のご連絡がない場合、採用プロジェクト担当から、書類の修正依頼や応募時必要情報の確認についてメールをお送りしている場合もありますので、ご確認ください。
          </AccordionItem>
          <AccordionItem
            title="求人内容の詳細について教えて欲しいことがあるのですが？"
            caption="※ご質問の種類は、「dodaエージェントサービスについて」をご選択ください。"
          >
            {otoiawase}
            より、該当する企業名と求人名、また質問事項を記載のうえ、ご連絡ください。
            <br />
            求人情報を担当する採用プロジェクト担当より、改めてご連絡を行います。
          </AccordionItem>
        </div>
        <Text color="gray" size="10">
          ※海外企業が雇用元となる求人にご応募いただいた場合、当該国の提携会社の担当者からご連絡を行うことがあります。あらかじめご了承ください。
          <br />
          <br />
          【拠点名】シンガポール：PERSOLKELLY Singapore Pte Ltd
          <br />
          香港：PERSOLKELLY Hong Kong Limited
          <br />
          韓国：PERSOLKELLY Korea, Ltd.
          <br />
          台湾：台灣英創管理顧問分有限公司
          <br />
          ベトナム：PERSOLKELLY Vietnam Company Limited
          <br />
          中国：英創人材服務（上海）有限公司、英創人力資源服務（深セン）有限公司
          <br />
          マレーシア：Agensi Pekerjaan PERSOLKELLY Malaysia Sdn. Bhd.
          <br />
          フィリピン：John Clements. Recruitemt,Inc.
          <br />
          タイ：PERSOLKELLY HR Services Recruitment (Thailand) Co., Ltd.
        </Text>
      </SectionItem>
    </div>
  );
};
